class PositionManager {
  constructor () {
    this.postionArr = []
    this.positionMap = {}
    this.maxItems = 50
  }

  addPosition (path, position) {
    let item = {path: path, position: position}
    this.deletePosition(path)
    this._checkMaxLength()
    this.postionArr.push(item)
    this.positionMap[item.path] = item
  }

  deletePosition (path) {
    let item = this.positionMap[path]
    if (!item) {
      return
    }
    delete this.positionMap[path]
    for (let index in this.postionArr) {
      if (this.postionArr[index].path === item.path) {
        this.postionArr.splice(index, 1)
        break
      }
    }
  }

  getPosition (path) {
    let item = this.positionMap[path]
    return item ? item.position : 0
  }

  _checkMaxLength () {
    let itemCount = this.postionArr.length - this.maxItems
    for (; itemCount > 0; itemCount--) {
      let delItem = this.postionArr.shift()
      delete this.positionMap[delItem.path]
    }
  }
}

export default new PositionManager()



// WEBPACK FOOTER //
// ./src/common/positionMan.js